import { IKnmParams } from 'APIPackage/KnmModule/interfaces/IKnmParams';

import { lodashGet } from '../../../functions/lodashGet';

/**
 * Рекурсивно удаляет значение из вложенного объекта по path в формате "parent.child"
 * @param obj - объект для удаления значения
 * @param path - путь к полю в формате "parent.child"
 * @returns true, если поле было удалено, false - если путь не найден
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const deleteNestedValue = (obj: Record<string, any>, path: string): boolean => {
  const parts = path.split('.');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let current: any = obj;

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < parts.length - 1; i++) {
    const part = parts[i];

    if (current == null || typeof current !== 'object' || !(part in current)) {
      return false;
    }
    current = current[part];
  }

  const lastPart = parts[parts.length - 1];

  if (current != null && typeof current === 'object' && lastPart in current) {
    delete current[lastPart];

    return true;
  }

  return false;
};

/**
 * Исключает указанные поля из объекта IKnmParams.
 * Поддерживает как верхнеуровневые поля, так и вложенные (например, "extendedData.subField").
 * Исключенные поля возвращаются отдельно для последующего восстановления.
 * @param params - исходные параметры
 * @param excludedFields - список полей для исключения (string[] или readonly string[])
 * @returns {{ filtered: IKnmParams, hasChanges: boolean }} объект с отфильтрованными параметрами и флагом изменений
 */
export const filterKnmParamsByExcludedFields = (
  params: IKnmParams,
  excludedFields: readonly string[],
): { filtered: IKnmParams; hasChanges: boolean } => {
  const filtered = JSON.parse(JSON.stringify(params));
  let hasChanges = false;

  excludedFields.forEach((field: keyof IKnmParams) => {
    const fieldPath = field as string;
    const value = lodashGet(filtered, fieldPath);

    if (value !== undefined) {
      deleteNestedValue(filtered, fieldPath);
      hasChanges = true;
    }
  });

  return { filtered, hasChanges };
};
